import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BackendService } from './backend.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VolunteerListItemResponse, VolunteerListResponse } from '../models/volunteer';
import { isEmpty } from 'lodash';
import { CustomHttpParamEncoder } from '../encoder/custom-http-param-encoder';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class VolunteerService {
  private baseURL: string = environment.baseUrl;
  constructor(private backendService: BackendService) {}

  getVolunteers(page: number, pageSize: number, activeFilters = {}, searchString?: string): Observable<VolunteerListItemResponse> {
    let params = new HttpParams({ encoder: new CustomHttpParamEncoder() });
    if (activeFilters) {
      Object.keys(activeFilters).forEach((key) => {
        params = params.append(key, activeFilters[key]!);
      });
    }

    if (searchString) params = params.append('search', searchString);

    let apiEndpoint = `${this.baseURL}/volunteers/?p=${page}&page_size=${pageSize}`;

    return this.backendService.getWithParams(apiEndpoint, { params }).pipe(
      map((res: VolunteerListResponse) => {
        const { results = [] } = res;
        const items = isEmpty(results)
          ? []
          : results.map((item) => {
              const { city, country } = item;
              const location = `${city}, ${country}`;
              return { ...item, location };
            });

        return { ...res, items };
      }),
    );
  }
}
